module.exports = __webpack_public_path__ + "static/share-2992c9626236b4f4b102c46d80f007fb.jpg";